<template>
	<!-- 添加消缺弹窗 -->
	<el-dialog
	  :title="title"
	  :visible.sync="dialogVisible"
	  v-dialogDrag
	  width="50%">
	  <el-form :model="form" :rules="rules" ref="form" label-width="100px" class="demo-ruleForm">
	    <el-form-item label="消缺名称" prop="name">
	      <el-input v-model="form.name"></el-input>
	    </el-form-item>
		<el-form-item label="缺陷等级" prop="priority">
		  <el-select v-model="form.priority" clearable placeholder="请选择">
		      <el-option
		        v-for="item in priorityList"
		        :key="item.value"
		        :label="item.name"
		        :value="item.value">
		      </el-option>
		  </el-select>
		</el-form-item>
		<el-form-item label="数据类型" prop="valueType">
		  <el-select v-model="form.valueType" clearable placeholder="请选择">
		      <el-option
		        v-for="item in valueTypeList"
		        :key="item.value"
		        :label="item.name"
		        :value="item.value">
		      </el-option>
		  </el-select>
		</el-form-item>
		<el-form-item label="缺陷危害" prop="harm">
		  <el-input type="textarea" v-model="form.harm" resize="none"></el-input>
		</el-form-item>
		<el-form-item label="处理建议" prop="proposal">
		  <el-input type="textarea" v-model="form.proposal" resize="none"></el-input>
		</el-form-item>
		<el-form-item label="消缺设备" prop="typeCode">
			<el-tree
			ref="tree"
			  v-model="form.typeCode"
			  :props="props"
			  :data="treeData"
			  show-checkbox
			  :node-key="'typeCode'"
			  :default-expand-all='false'
			  :default-expanded-keys="defaultexpandedKeys"
			  :default-checked-keys="defaultcCheckedkeys"
			  @check-change="handleCheckChange">
			</el-tree>
		</el-form-item> 
	  </el-form>
	  <span slot="footer" class="dialog-footer">
	    <el-button size="small" @click="closeDialog">取 消</el-button>
	    <el-button size="small" type="primary" @click="saveDefect">保 存</el-button>
	  </span>
	</el-dialog>
</template>

<script>
	export default {
		components: {},
		props: {},
		data() {
			return {
				title: '',
				callback: undefined, 
				dialogVisible: false,
				innerVisible: false,
				form: {
					name: '',
					priority: '',
					valueType: '',
					harm: '',
					proposal: '',
					defectType: 'check',
					device: [],
					typeCode: '',
					typeName:''
				},
				rules: {
					name: [
						{ required: true, message: '请输入消缺名称', trigger: 'blur' },
						{ min: 1, max: 20, message: '长度在 1 到 20 个字符', trigger: 'blur'}
					],
					priority: [
						{required: true, message: '请选择缺陷等级', trigger: 'blur'}
					],
					valueType: [
						{required: true, message: '请选择数据类型', trigger: 'blur'}
					],
					harm: [
						{required: true, message: '缺陷危害内容不能为空', trigger: 'blur' },
					],
					proposal: [
						{required: true, message: '处理建议内容不能为空', trigger: 'blur' },
					],
					typeCode: [
						{required: true, message: '至少要选择一个设备', trigger: 'blur' },
					],
				},
				props: {
					children: 'children',
					label: 'typeName',
					value: 'typeCode'
				},
				treeData: [],
				nowCheckedDevices: [],
				confirmDevices: [],
				defaultcCheckedkeys: [],
				defaultexpandedKeys: []
			}
		},
		created() {},
		mounted() {
			
		},
		destroyed() {},
		computed: {
			
			priorityList() {
				return this.$store.orderGroupStore.state.priorityList
			},
			valueTypeList() {
				return this.$store.enumStore.state.valueTypeList
			},
			checkData() {
				if(isempty(this.form) || this.form.name == '' || this.form.priority == '' || this.form.valueType == '' || this.form.proposal == '' || this.form.harm == '') {
					this.$message({
						message: '内容不能为空！',
						type: 'warning'
					})
					return false
				}else if(this.form.name.length > 20) {
					this.$message({
						message: '消缺名称的字符长度不能超过20',
						type: 'warning'
					})
					return false
				}
				if(isempty(this.form.typeCode)){
					this.$message({
						message: '至少要选择一个设备！',
						type: 'warning'
					})
					return false
				}
				return true
			},
		},
		watch: {},
		methods: {
			/* handleClose(done) {
				this.$confirm('确认关闭？')
				.then(_ => {
					done();
				})
				.catch(_ => {});
			}, */
			// 保存
			saveDefect() {
				/* if(!this.checkData) {
					return
				}  */
				this.$refs.form.validate(valid => {
					if (valid) {
						this.callback(this.form)
						this.closeDialog()
					}
				})
			},
			closeDialog() {
				this.dialogVisible = false
				this.defaultcCheckedkeys = []
				this.defaultexpandedKeys = []
				this.form = {
					name: '',
					priority: '',
					harm: '',
					proposal: '',
					defectType: 'check',
					device: [],
				}
			},
			handleCheckChange(data, checked, indeterminate) {
				let nowCheckNodes = this.$refs.tree.getCheckedNodes()
				let typeCode = []
				for(let i = 0; i < nowCheckNodes.length; i++) {
					typeCode.push(nowCheckNodes[i].typeCode)
				}
				this.form.typeCode = copy(typeCode.join(','))
			},
			// 从选中的节点数据中提取出来设备列表
			//getCheckedDevices(list, arr) {
			  getCheckedDevices(list) {
				var typeCodelist = []
				var typeNamelist = []
				for(let i = 0;i < list.length;i++) {
					//this.defaultcCheckedkeys.push(list[i].typeCode)
					 typeCodelist.push(list[i].typeCode)
					 typeNamelist.push(list[i].typeName)
				}
				this.form.typeCode = copy(typeCodelist.join(','))
				this.form.typeName = copy(typeNamelist.join(','))
				/* for(let i = 0;i < list.length;i++) {
					if(list[i].children == undefined) {
						arr.push(list[i])
					}else if(!isempty(list[i].next)) {
						this.getCheckedDevices(list[i].next, arr)
					}
				} */
			},
			// 确认选中设备
			confirmSelect() {
				this.innerVisible = false
				//this.confirmDevices = copy(this.nowCheckedDevices)
				//var deviceList = []
				var checkedNodes = this.$refs.tree.getCheckedNodes()
				//this.getCheckedDevices(checkedNodes, deviceList)
				this.getCheckedDevices(checkedNodes)
				//this.nowCheckedDevices = deviceList
			},
			open(title, defectData, callback) {
				//加载消缺设备
				this.$api.entityApi.getEntityTypeList(respon => {
					if(!isempty(respon)) {
						this.treeData = copy(deviceList(respon))
					}
				})

				this.form = {}
				this.defaultcCheckedkeys = []
				this.defaultexpandedKeys = []

				if(!isempty(defectData)) {
					//if(!isempty(defectData.typeCode)) {
						this.defaultcCheckedkeys = defectData.typeCode.split(',')
						this.defaultexpandedKeys = defectData.typeCode.split(',')
					//}
					this.form = {
						name: defectData.name,
						priority: defectData.priority,
						valueType: defectData.valueType,
						harm: defectData.harm,
						proposal: defectData.proposal,
						defectType: 'check',
						//typeName: defectData.typeName,
						typeCode: defectData.typeCode
					}
					
				}
				this.title = title
				this.callback = callback
				this.dialogVisible = true
			}
		}
	}
</script>

<style scoped>
	.deviceNameBox {
		display: inline-block;
		color: #409EFF;
		background-color: #ECF5FF;
		border: solid 1px #409EFF;
		line-height: 32px;
		margin-right: 8px;
		border-radius: 3px;
		padding: 0 8px;
	}
</style>